import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

//AngularFire
import { AngularFireStorage } from '@angular/fire/storage';

import { ProductService, ToasterService, CategoryService  } from '../../_services';
import { NgxSpinnerService } from "ngx-spinner";
import { Ng2ImgMaxService } from 'ng2-img-max';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss']
})

export class EditProductComponent implements OnInit {
  editProductForm:FormGroup;
  ref:any;
  downloadURL: Observable<string>;
  pictureFile:any;
  pictureEventTarget:any;
  ref2:any;
  downloadURL2: Observable<string>;
  pictureFile2:any;
  pictureFileName2:string;
  pictureDownloadUrl:string;
  videoDownloadUrl:string;
  productId:string;
  productData:any;
  pictureArr:any[] = [];
  categoryList:any;
  categoryName:any;
  uploadedImage:any[]=[];
  gkcId:string;
  constructor(
    public dialogRef: MatDialogRef<EditProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _product : ProductService,
    private afStorage: AngularFireStorage,
    private spinner: NgxSpinnerService,
    private _toaster: ToasterService,
    private _category : CategoryService,
    private ng2ImgMax: Ng2ImgMaxService
  ) { }

  ngOnInit(): void {
    this.productId = this.data.id;
    this.editProductForm = this.formBuilder.group({
      sku: [null, []],
      name: [null, []],
      description: ["", []],
      dimensions_length: [null, []],
      dimensions_width : [null, []],
      dimensions_depth : [null, []],
      dimensions_height : [null, []],
      weight: [null, []],
      shape: [null, []],
      style: [null, []],
      video_url: [null, []],
      price_gkc: [null, []],
      price_selling: [null, []],
      category_id  :["", []],
      color: [null, []],
    })
    this.getProductDetailById();
    this.getProductGKCPriceById();
    this.getCategoryList();
  }

  getCategoryList(){
    this.spinner.show();
    this._category.getCategoryList().subscribe(result=>{
      this.categoryList = result;
      this.spinner.hide();
    },err=>{
      alert("Something went wrong");
    })
  }

  getProductDetailById(){
    this.spinner.show();
    this._product.getProductDetailById(this.productId).subscribe(result=>{
      this.productData = result;
      //Patch value
      if(this.productData && this.productData.length>0){
        this.editProductForm.patchValue({
          sku: this.productData[0].payload.doc.data().sku,
          name: this.productData[0].payload.doc.data().name,
          description: this.productData[0].payload.doc.data().description,
          dimensions_length: this.productData[0].payload.doc.data().dimensions_length,
          dimensions_width: this.productData[0].payload.doc.data().dimensions_width,
          dimensions_depth: this.productData[0].payload.doc.data().dimensions_length,
          dimensions_height: this.productData[0].payload.doc.data().dimensions_length,          
          weight: this.productData[0].payload.doc.data().weight,
          shape: this.productData[0].payload.doc.data().shape,
          style: this.productData[0].payload.doc.data().style,
          video_url: this.productData[0].payload.doc.data().video_url,
          price_selling: this.productData[0].payload.doc.data().price_selling,
          category_id: this.productData[0].payload.doc.data().category_id,
          color: this.productData[0].payload.doc.data().color,
        });
        this.pictureArr = this.productData[0].payload.doc.data().pictures && this.productData[0].payload.doc.data().pictures.length>0 ? this.productData[0].payload.doc.data().pictures : [];
      }

    this.spinner.hide();
    },err=>{
      alert("Something went wrong");
    })
  }

  getProductGKCPriceById(){
    this._product.getProductGKCPriceById(this.productId).subscribe(result2=>{
      //Patch value
      if(result2.length>0){
        this.gkcId = result2[0].payload.doc.id;
        this.editProductForm.patchValue({
          price_gkc: result2[0].payload.doc.data().price_gkc
        });
      }
    },err=>{
      alert("Something went wrong");
    })
  }

  setCategoryId(id){
    const selectedCat = this.categoryList.find(item=>item.payload.doc.id===id);
    this.categoryName = selectedCat && selectedCat.payload ? selectedCat.payload.doc.data().name : ''; 
  }

  hideDialog() {
    this.dialogRef.close();
  }

  removePicture(img){
    let index = this.pictureArr.indexOf(img);
    if (index !== -1) {
      this.pictureArr.splice(index, 1);
    }
    
  }

    // Upload Picture...
  async  uploadPicture(event){
      this.pictureFile = (event.target as HTMLInputElement).files;
      const randomId = Math.random().toString(36).substring(2);
      this.pictureEventTarget = event.target.files
      // this.ref = this.afStorage.ref(`products/${randomId}-${event.target.files[0].name}`);
          // let image = event.target.files[0];
    for(let i=0; i<this.pictureFile.length; i++){
      this.ng2ImgMax.resizeImage(event.target.files[i], 500, 500).subscribe(
        result => {
          this.uploadedImage.push(result);
        },
        error => {
          console.log('Something went wrong!', error);
        }
      );
    }

    }

    // // Upload Video
    // uploadVideo(event){
    //   this.pictureFile2 = (event.target as HTMLInputElement).files;
      
    //   const randomId = Math.random().toString(36).substring(2);
    //   this.pictureFileName2 = `${randomId}-${event.target.files.name}`
    //   this.ref2 = this.afStorage.ref(`products/${randomId}-${event.target.files.name}`);
    // }

  async onFormSubmit(){
    
    this.spinner.show();
    const formData = this.editProductForm.value;
    formData.category_name = this.categoryName ? this.categoryName : this.productData[0].payload.doc.data().category_name? this.productData[0].payload.doc.data().category_name :'';             
    formData.pictures = this.pictureArr;
    if(formData.price_gkc!= null){
      if(this.gkcId){
        this._product.editProductGKC({price_gkc: formData.price_gkc},this.gkcId).then(async (res:any) => {
        }).catch(err=>{
          this._toaster.showError("'Product not edited!", "Error");
        })
      }
      else {
        const obj = {
          date_created: new Date().getTime(),
          date_updated: new Date().getTime(),
          item_id: this.productId,
          price_gkc: formData.price_gkc
        }

        this._product.addProductGKC(obj).then(async (res:any) => {
        }).catch(err=>{
          this._toaster.showError("'Product GKC not updated!", "Error");
        })
      }
    }
    
    // if(!this.pictureFile){
    //   this._product.editProduct({pictures:this.pictureArr},this.productId).then(async (res2:any) => {
    //   },err=>{
    //   })  
    // }

    this._product.editProduct(formData,this.productId).then(async (res:any) => {
      // upload picture files                                 
      if(this.pictureFile) {
        const pictureArr2 = this.pictureArr;
        for(let i=0; i<this.pictureFile.length; i++){
          const randomId = Math.random().toString(36).substring(2);
          const fileName = `${randomId}-${this.pictureFile[i].name}`
          this.ref = this.afStorage.ref(`products/${randomId}-${this.pictureFile[i].name}`);
          const task = await this.afStorage.upload(`products/${randomId}-${this.pictureFile[i].name}`,this.uploadedImage[i]); // this.pictureFile[i]
          this.downloadURL = this.ref.getDownloadURL();
          this.downloadURL.subscribe(url => {
            let obj = {
              path : `products/${randomId}-${this.pictureFile[i].name}`,
              download_url : url,
              date_created: new Date().getTime()
            }
            pictureArr2.push(obj);
            if(i+1===this.pictureFile.length){
              this._product.editProduct({pictures:pictureArr2},this.productId).then(async (res2:any) => {
              },err=>{
              })  
            }
           
          });
        }

      }

      this.spinner.hide();
      this.dialogRef.close();
      this._toaster.showSuccess("Product edited successfully!", "Success");
    }).catch(err=>{
      this.spinner.hide();
      this.dialogRef.close();
      this._toaster.showError("'Product not edited!", "Error");
    })

  }

}
